import React from "react";
import { Container, Box, Typography, IconButton, useMediaQuery } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

function Footer() {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: "#76959c",
                color: "#fff",
                minHeight: "100px",
                py: 3, // Padding'i artırdım
                mt: 4, // Üst boşluğu artırdım
                display: "flex",
                alignItems: "center",
                justifyContent: "center", // İçeriği ortaladım
                position: isMobile ? "static" : "sticky", // Mobilde static, webde sticky
                bottom: 0,
                left: 0,
                width: "100%",
                zIndex: 1300,
            }}
        >
            <Container maxWidth="md">
                <Box
                    display="flex"
                    justifyContent="space-between"
                    flexDirection={{ xs: "column", md: "row" }}
                    alignItems={{ xs: "center", md: "flex-start" }} // Dikeyde hizalamayı düzelttim
                    textAlign={{ xs: "center", md: "left" }}
                    gap={4}
                >
                    <Box>
                        <Typography variant="body2">
                            {t("footer.copyright")}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                            {t("footer.about")}
                        </Typography>
                        <Typography variant="body2">
                            {t("footer.terms")}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                            {t("footer.contact")}
                        </Typography>
                        <Typography variant="body2">
                            <b>{t("footer.addressLabel")}:</b> {t("footer.address")}
                        </Typography>
                        <Typography variant="body2">
                            <b>{t("footer.emailLabel")}:</b> {t("footer.email")}
                        </Typography>
                        <Typography variant="body2">
                            <b>{t("footer.phoneLabel")}:</b> {t("footer.phone")}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                            {t("footer.followUs")}
                        </Typography>
                        <Box>
                            <IconButton
                                aria-label="Facebook"
                                href="https://facebook.com"
                                target="_blank"
                                sx={{ color: "#fff" }}
                            >
                                <FacebookIcon />
                            </IconButton>
                            <IconButton
                                aria-label="Instagram"
                                href="https://instagram.com"
                                target="_blank"
                                sx={{ color: "#fff" }}
                            >
                                <InstagramIcon />
                            </IconButton>
                            <IconButton
                                aria-label="LinkedIn"
                                href="https://www.linkedin.com/"
                                target="_blank"
                                sx={{ color: "#fff" }}
                            >
                                <LinkedInIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;